module.exports = __webpack_public_path__ + "img/icon6.0a020284.png";